export default {
	listen: (component, obj) => {
		component.$watch(
			() => obj,
			function (newValue) {
				Object.keys(newValue).forEach(key => {
					component.$emit('update:' + key, obj[key]);
				});
			},
			{ deep: true, immediate: true },
		);
	},
};
